const Vehicle = {

    // FIELDS
    "registration_number": "رقم التسجيل",
    "make": "الصانع",
    "model": "النموذج",
    "year": "السنة",
    "color": "اللون",
    "mileage": "المسافة المقطوعة",
    "capacity": "السعة",
    "current_status": "الحالة الحالية",
    "driver_attender": "السائق / المرافق",
    "warehouse_details": "تفاصيل المستودع",
    "business_area": "مجال العمل",
    "email": "البريد الإلكتروني",
    "search": "البحث",

    // PAGE HEADER
    "vehicle": "المركبة",

    // ERROR
    "error_registration_number": "الرجاء إدخال رقم التسجيل",
    "error_make": "الرجاء إدخال الصانع",
    "error_model": "الرجاء إدخال النموذج",
    "error_year": "الرجاء إدخال السنة",
    "error_color": "الرجاء إدخال اللون",
    "error_mileage": "الرجاء إدخال المسافة المقطوعة",
    "error_capacity": "الرجاء إدخال السعة",
    "error_current_status": "أدخل الحالة الحالية",
    "error_driver_attender": "يرجى اختيار السائق / المرافق",
    "error_business_area": "اختر مجال العمل",
    "error_email": "اختر البريد الإلكتروني",

    // TABLE HEADER
    "table_regitration_number": 'رقم التسجيل',
    "table_make": "الصانع",
    "table_model": "النموذج",
    "table_capacity": "السعة",
    "table_current_status": "الحالة الحالية",
}

export default Vehicle;